<template>
    <div id="app">
        <div id="loading">
            <div>
                <div>
                    <img src="./assets/imgs/general/dintica-loader.png" alt="">
                </div>
                <div class="text">
                    Tuti, Dințișorul Zurliu se pregătește de aventură
                </div>
            </div>
        </div>
        <div id="landing" class="d-none">
            <Navbar></Navbar>

            <router-view/>

            <!--<Landing></Landing>-->

            <Footer></Footer>
        </div>

    </div>
</template>

<script>
    // import Landing from './components/Landing.vue'
    import Navbar from './components/partials/Navbar.vue'
    import Footer from './components/partials/Footer.vue'

    export default {
        name: 'app',
        components: {
            // Landing,
            Navbar,
            Footer
        },
        data() {
            return {
                baseUrl: process.env.VUE_APP_BASE_URL,
            }
        },
        mounted() {
            const $ = window.$;

            // console.log('base url', process.env, process.env.BASE_URL, process.env.VUE_APP_BASE_URL)

            // this.$store.commit('setBaseUrl', this.baseUrl);
            this.$cookie.set('base-url', this.baseUrl);

            $(document).ready(function () {
                window.cookieconsent.initialise({
                    container: document.getElementById("cookieconsent"),
                    palette: {
                        popup: {background: "#0b4366"},
                        button: {background: "#ffffff"},
                    },

                    onStatusChange: function () {
                        console.log('status change', this.hasConsented() ? 'enable cookies' : 'disable cookies');
                        var type = this.options.type;
                        var didConsent = this.hasConsented();
                        if ((type == 'opt-in' || type == 'opt-out') && didConsent) {
                            enableGoogleAnalytics();
                        }
                        if ((type == 'opt-in' || type == 'opt-out') && !didConsent) {
                            disableGoogleAnalytics();
                        }
                    },
                    onRevokeChoice: function () {
                        console.log('revoke', this.options.type);
                    },
                    revokable: true,
                    position: "bottom-left",
                    theme: "classic",
                    domain: "https://spiridusidenadejde.ro",
                    secure: true,
                    type: 'opt-out',

                    content: {
                        header: 'Cookies used on the website!',
                        message: 'Acest website folosește cookie-uri pentru a oferi o experiență mai bună.',
                        dismiss: 'dismiss  Got it!',
                        allow: 'Acceptă cookie-uri',
                        deny: 'Refuză cookie-uri',
                        link: 'Află mai multe.',
                        href: '../../docs/politica_de_cookies.pdf',
                        close: '&#x274c;',
                        policy: 'Politica de cookies',
                    },

                });

                function gtag() {
                    window.dataLayer.push(arguments);
                }


                function enableGoogleAnalytics() {
                    console.log('enableGoogleAnalytics');
                    window.dataLayer = window.dataLayer || [];

                    gtag('js', new Date());
                    gtag('config', 'UA-60532974-5');

                    (function (w, d, s, l, i) {
                        w[l] = w[l] || [];
                        w[l].push({
                            'gtm.start':
                                new Date().getTime(), event: 'gtm.js'
                        });
                        var f = d.getElementsByTagName(s)[0],
                            j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                        j.async = true;
                        j.src =
                            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                        f.parentNode.insertBefore(j, f);
                    })(window, document, 'script', 'dataLayer', 'GTM-WTQZNH5');
                }

                function disableGoogleAnalytics() {
                    console.log('disable');
                    delete_cookie('_ga');
                    delete_cookie('_gid');
                    delete_cookie('_gat_gtag_UA-60532974-5');
                    delete_cookie('_gat_UA-60532974-5');
                }

                function delete_cookie(name) {
                    document.cookie = 'Name=' + name + '=; Value=0; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                }

            });
        }
    }
</script>

<style lang="scss">
    @import './styles/variables.scss';
</style>
